import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewGeneralInvoicesComponent } from 'src/app/layouts/admin/components/payment-section/view-general-invoices/view-general-invoices.component';
import { AdminService } from 'src/app/services/admin/admin.service';

@Component({
  selector: 'app-invoice-complete-modal',
  templateUrl: './invoice-complete-modal.component.html',
  styleUrls: ['./invoice-complete-modal.component.scss']
})
export class InvoiceCompleteModalComponent {
  @Input() modelId: any;
  @Input() title: any;
  @Input() modalName: string;

  @Input() type: string;
  @Input() shops: any;
  @Input() brands: any;
  @Input() showSendInvoice: string;
  @Input() selectedInvoice: any;
  loading: boolean = false
  submitted: boolean = false

  @Output() hideModals = new EventEmitter();

  completeGenerate: FormGroup = new FormGroup({
    status: new FormControl(''),
    referance: new FormControl('', [Validators.required]),
    payment_method: new FormControl(null, [Validators.required]),
  })
  get controls() { return this.completeGenerate.controls; }

  constructor(
    private adminService: AdminService,
    private spinner: NgxSpinnerService
  ) {
  }


  ngOnInit() {
    // console.log(this.selectedInvoice, 'selectedInvoice');
    
    this.spinner.show()

  }

  completeGeneration() {
    console.log(this.completeGenerate.value, "this.completeGenerate.value");
    this.loading = true
    this.submitted = true;
    if (this.completeGenerate.invalid) {
      this.completeGenerate.setErrors({
        invalidLogin: true
      })

      this.loading = false;
    } else {
      const formData = new FormData();
      formData.append('status', '1')
      formData.append('referance', this.completeGenerate.value.referance)
      formData.append('payment_method', this.completeGenerate.value.payment_method)
      formData.append('_method', "PUT")

      this.adminService.updateInvoice(this.selectedInvoice?.id, formData)
        .subscribe({
          next: (res) => {
            console.log(res, "updateInvoice");
            this.loading = false;
            this.hideModals.emit()
            this.completeGenerate.reset()
            this.submitted = false;
          },
          error: (error) => {
            console.log(error);
            this.loading = false;
          }
        });

    }
  }

  clearData(){
    this.submitted = false;
    this.completeGenerate.reset()
  }
}
